export default {
  App: {
    close: 'Schließen'
  },
  AgencyOverviewStatements: {
    heading: 'Provisionsabrechnungen',
    date: 'Datum',
    contractsNumber: 'Anzahl Verträge',
    commissionSum: 'Provision',
    errorWhileDownloading: 'Fehler beim Herunterladen'
  },
  AppLayout: {
    logoutText: 'Abmelden',
    search: 'Suche (Angestellte, Hilfe, ...)'
  },
  AuthLayout: {
    forgotPassword: 'Passwort vergessen',
    home: 'Startseite',
    login: 'Anmelden',
    errorWhileLoadingTranslations: 'Übersetzungen konnten nicht geladen werden'
  },
  CompanyEditor: {
    address: 'Adressdaten',
    basicData: 'Basisdaten',
    contact: 'Kontaktdaten',
    contactPerson: 'Kontaktperson',
    email: 'E-Mail',
    emailNotValid: 'Keine gültige Email',
    fax: 'Fax',
    isRequired: 'Benötigt',
    name: 'Firmenname',
    phone: 'Telefon',
    save: 'Speichern',
    street: 'Straße, Hausnummer',
    vatNumber: 'USt-ID Nr.'
  },
  CompanyLogEntries: {
    timesheet: {
      create: '<a href="{href}">Stundennachweis</a> (ID: {id}) wurde erstellt',
      multiple_months_batch: {
        success: 'Der Stundennachweis {month} für einen <a href="{href}">Mitarbeiter</a> (ID: {id}) wurde erstellt'
      },
      multiple_users_batch: {
        success: 'Der Stundennachweis {month} für einen <a href="{href}">Mitarbeiter</a> (ID: {id}) wurde erstellt'
      }
    },
    employee: {
      update: 'Ein <a href="{href}">Mitarbeiter</a>  (ID: {id}) wurde bearbeitet',
      delete: 'Ein Mitarbeiter  (ID: {id}) wurde entfernt',
      create: 'Ein <a href="{href}">Mitarbeiter</a>  (ID: {id}) wurde erstellt',
      assigned_as_manager: 'Der <a href="{href}">Mitarbeiter</a>  (ID: {id}) wurde die Rolle Manager zugewiesen. '
    },
    employee_account: {
      create: 'Ein <a href="{href}">Mitarbeiteraccount</a>  (ID: {id}) wurde erstellt'
    },
    timetracking: {
      start: 'Der <a href="{href}">Mitarbeiter</a>  (ID: {id}) hat die Zeitmessung gestartet',
      stop: 'Der <a href="{href}">Mitarbeiter</a>  (ID: {id}) hat die Zeitmessung angehalten'
    },
    activity_period: {
      create: 'Der <a href="{href}">Mitarbeiter</a>  (ID: {id}) wurde für die Periode {period} als inaktiv markiert ',
      delete: 'Die Inaktivitätsperiode {period} wurde für den Mitarbeiter <a href="{href}">Mitarbeiter</a>  (ID: {id}) entfernt '
    },
    salaryGroup: {
      create: 'Eine Lohngruppe (ID: {id}) wurde erstellt',
      delete: 'Eine Lohngruppe (ID: {id}) wurde bearbeitet',
      update: 'Eine Lohngruppe (ID: {id}) wurde entfernt'
    }
  },

  CompanyOverview: {
    heading: 'Firmenübersicht',
    info: 'Informationen',
    log: 'Log',
    salary: 'Lohngruppen'
  },
  CompanySalary: {
    add: 'Neue erstellen',
    cancel: 'Abbrechen',
    create: 'Erstellen',
    createHeading: 'Neue Gruppe anlegen',
    deleteAccept: 'Entfernen',
    deleteBody: 'Nur Lohngruppen ohne zugewiesene Mitarbeiter können entfernt werden.',
    deleteHeader: 'Lohngruppe entfernen?',
    edit: 'Speichern',
    editHeading: 'Bearbeiten',
    heading: 'Lohngruppen',
    hourlyWage: 'Stundenlohn',
    name: 'Name'
  },
  CreateEmployeesTimesheetBatchDialog: {
    heading: 'Mehrere Dokumente erzeugen'
  },
  DeleteEntry: {
    cancel: 'Abbrechen',
    delete: 'Entfernen'
  },
  EmailInput: {
    emailNotValid: 'Ungültige Email',
    emailRequired: 'Pflichtfeld',
    label: 'Email'
  },
  GlobalNotifications: {
    close: 'Schließen'
  },
  Languages: {
    de: 'Deutsch',
    en: 'Englisch'
  },
  Login: {
    heading: 'Anmelden',
    labelPassword: 'Passwort',
    passwordMin8Chars: 'Mindestens 8 Zeichen',
    send: 'Anmelden',
    forgotPassword: 'Password vergessen'
  },
  MyCompany: {
    heading: 'Firmendaten',
    pleaseFillCompanyData: 'Füllen sie bitte alle Daten aus, um die Plattform zu nutzen'
  },
  NotificationBlock: {
    noContent: 'Keine Nachrichten'
  },
  PasswordForgot: {
    heading: 'Passwort vergessen',
    send: 'Passwort anfordern',
    back: 'Zurück'
  },
  PasswordReset: {
    setPassword: 'Passwort setzen',
    resetPassword: 'Passwort zurücksetzen',
    send: 'Passwort anfordern',
    back: 'Zurück'
  },
  PasswordPair: {
    label: 'Passwort',
    labelConfirm: 'Passwort wiederholen',
    passwordMin8Chars: 'Mindestens 8 Zeichen',
    passwordNotMatching: 'Passwörter nicht gleich'
  },
  Referrals: {
    copiedToClipboard: 'In Zwischenablage kopiert',
    createdAt: 'Geworben am',
    email: 'E-Mail',
    heading: 'Partnerprogramm',
    headingAllReferrals: 'Ihre bisher geworbenen Mitglieder',
    link: 'Werbelink',
    linkHint: 'Kopieren Sie diesen Werbelink und geben Sie ihn Freunden und Bekannten',
    name: 'Name',
    noRefs: 'Bisher haben Sie noch keine Mitglieder geworben',
    refId: 'Partner ID',
    status: 'Bezahlstatus'
  },
  SelectCity: {
    label: 'Stadt',
    loading: 'loading...',
    noData: 'Keine Stadt gefunden',
    placeholder: 'Nach Stadt oder Postleitzahl suchen...'
  },
  Settings: {
    email: 'Email ändern',
    gdpr: 'DSGVO',
    heading: 'Einstellungen',
    password: 'Passwort ändern',
    personalInfo: 'Persönliche Daten'
  },
  SidebarBlock: {
    settings: 'Einstellungen',
    customerCreate: 'Neuer Kunde',
    agentContracts: 'Vertragsübersicht',
    agencySettings: 'Agentureinstellungen',
    agencyAgents: 'Mitarbeiter',
    agencyContracts: 'Verträge',
    agencyStatements: 'Abrechnungen',
    contractCreate: 'Neuer Vertrag'
  },
  AgencySettings: {
    heading: 'Agentureinstellungen',
    agencyEdit: 'Basisdaten',
    agencyContacts: 'Kontaktdaten',
    agencyAddress: 'Adresse',
    agencyCredentials: 'Bankdaten',
    agencyDisable: 'Sperren'
  },
  AgencyContracts: {
    heading: 'Vertragsübersicht'
  },
  AgencyAgents: {
    heading: 'Mitarbeiterübersicht'
  },
  AgencyStatements: {
    heading: 'Provisionsabrechnungen'
  },

  AgencyCredentials: {
    iban: 'IBAN',
    bic: 'BIC',
    bankname: 'Bankname',
    editAgency: 'Speichern'
  },
  AgencyAddress: {
    street: 'Straße',
    zip: 'PLZ',
    city: 'Ort',
    editAgency: 'Speichern'
  },
  AgencyContacts: {
    contact_person: 'Kontaktperson',
    phone: 'Telefon',
    mobile_number: 'Mobil',
    editAgency: 'Speichern'
  },
  AgencyOverviewAgentsTable: {
    heading: 'Mitarbeiterübersicht',
    number: 'MA-Nr.',
    name: 'Name'
  },
  AgencyOverviewContractsList: {
    heading: 'Verträge',
    noInfoYet: 'Keine Abschlüsse bisher',
    name: 'Firma',
    package: 'Paket',
    packageCost: 'Paketpreis'
  },
  AgencyOverviewAgentsCreateEntry: {
    heading: 'Neuer Verbriebsmitarbeiter',
    createEntry: 'Mitarbeiter erstellen',
    firstName: 'Vorname',
    lastName: 'Nachname',
    cancel: 'Abbrechen',
    create: 'Erstellen',
    number: 'Mitarbeiternummer'
  },
  ConfirmModal: {
    cancel: 'Abbrechen',
    ok: 'Ok'
  },
  AgencyDisable: {
    headline: 'Vertriebspartner sperren',
    disableUserWarn: `Durch das Sperren der Agentur werden alle Logins dieser 
    Agentur gesperrt, sodass keine neuen Kunden geworben werden können. `,
    disableButton: 'Agentur sperren',
    disableHeader: 'Sperrung bestätigen',
    disableBody: 'Wollen Sie diese Agentur wirklich sperren? ',
    disable: 'Sperren',
    enable: 'Freischalten',
    enableUserWarn: 'Nach dem freischalten, werden alle Logins wieder funktionieren. ',
    enableHeader: 'Agentur freischalten',
    enableButton: 'Freischalten',
    enableBody: 'Wollen Sie die Agentur wieder freischalten?'
  },
  AgenciesList: {
    heading: 'Agenturen',
    name: 'Name',
    number: 'Nummer',
    commission: 'Provision'
  },
  AgentContracts: {
    createContract: 'Neuer Vertrag'
  },
  AgentSettings: {
    heading: 'Agent-Einstellungen',
    agentEdit: 'Persönliche',
    agentDisable: 'Deaktivieren'
  },
  AgentEdit: {
    firstName: 'Vorname',
    lastName: 'Nachname',
    editAgent: 'Speichern',
    number: 'Mitarbeiternummer'
  },
  ContractCreate: {
    createCustomer: 'Vertrag erstellen',
    createAgency: 'Neuer Kunde',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'Email',
    user: 'Benutzerdaten',
    company: 'Firmendaten',
    companyName: 'Firmenname',
    companyStreet: 'Straße, Hausnummer',
    city: 'Stadt',
    companyPhone: 'Telefon',
    add: 'erstellen'
  },
  ContractsTable: {
    heading: 'Vertragsübersicht',
    name: 'Firma',
    package: 'Paket',
    packageCost: 'Monatl. Paketpreis',
    not_subscribed: 'Inaktiver Vertrag',
    noInfoYet: 'Keine Daten'
  },

  ValidationRules: {
    isRequired: 'Benötigtes Feld',
    isValidPassword: 'Mindestens 8 Zeichen',
    isValidEmail: 'Keine gültige Email',
    isValidNumber: 'Keine ganze Zahl',
    isPasswordMatch: 'Passwörter nicht gleich',
    isPercent: 'Wert zwischen 0 und 100'
  },
  EmailSettings: {
    attention: 'Eine neue Email Adresse wird erst akzeptiert, nachdem Sie diese bestätigt haben. ',
    edit: 'Speichern'
  },
  GdprSettings: {
    acceptGdpr: 'Vereinbarung akzeptieren',
    body: 'Am 25. Mai 2018 tritt die neue Verordnung zur Verarbeitung personenbezogener Daten durch private Unternehmen und öffentliche Stellen in Kraft. Wenn Ihr Firmensitz innerhalb der EU liegt oder sie Kunden aus der EU haben, müssen Sie bis zum Stichtag eine Vereinbarung zur Auftragsverarbeitung mit uns abschließen.',
    heading: 'EU-Richtlinien zum Datenschutz (DSGVO)',
    validGdpr: 'Sie haben mit uns am {date} um {time} Uhr eine gültige Vereinbarung zur Auftragsverarbeitung abgeschlossen.'
  },
  PasswordSettings: {
    edit: 'Speichern',
    labelConfirm: 'Bestätigen Sie bitte ihr altes Passwort'
  },
  PersonalInfoSettings: {
    edit: 'Speichern',
    firstName: 'Vorname',
    lastName: 'Nachname',
    selectLanguage: 'Sprache wählen'
  },
  timesheetDay: {
    timePickerEnd: 'Ende Arbeitszeit'
  },
  disabledUserButton: {
    pleaseSignUp: 'Dies ist eine Demoversion, zur Nutzung bitte ein Abonnement abschließen'
  },
  AgentDisable: {
    enableHeader: 'Bestätigung der Entsperrung',
    disableHeader: 'Bestätigung der Sperrung',
    enableBody: 'Wollen Sie diesen Benutzer wirklich entsperren? ',
    disableBody: 'Wollen Sie diesen Benutzer wirklich sperren? ',
    enable: 'Benutzer entsperren',
    disable: 'Benutzer sperren',
    headline: 'Benutzer sperren',
    enableUserWarn: 'Durch das entsperren wird der Benutzer wieder aktiviert. Anschließend kann er sich anmelden und seinen Konto wie bisher weiter nutzen. ',
    disableUserWarn: 'Hier können Sie den Benutzer sperren. Nach dem Sperren wird sich dieser Benutzer nicht mehr anmelden können und kann die Plattform nicht mehr nutzen. Seine Daten bleiben erhalten, sein Abonnement wird nicht gestoppt. ',
    enableButton: 'Benutzer entsperren',
    disableButton: 'Benutzer sperren',
  },
  SubscriptionPlans: {
    body: 'Hier können Sie ihr aktuelles Abonnement ändern. ',
    package: 'Paket',
    choosePlan: 'Bitte ein Paket wählen',
    packageCost: 'Preis',
    changePlan: 'Paket wechseln',
    planName: 'Max. {employees} Mitarbeiter — {price} im Monat',
    next: 'Weiter'
  },
  AdminAgencySettings: {
    heading: 'Agenturverwaltung',
    agencyEdit: 'Bearbeiten',
    agencyDisable: 'Entfernen'
  },
}
